/* (not using these - at least for now)
import _ from 'lodash'
const optionsPaneLetterKeyOrder = 'FSJLREIOVCXM' // duplicated in NikudOptionsPane
const optionsPaneNumberKeyOrder = '0123456789' // duplicated in NikudOptionsPane
*/
export default {
  name: 'nikudOptionsPaneKeyMap',
  data () {
    var nikudKeys = {}
    nikudKeys['down'] = () => { 
      if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) this.moveToNextOption()
    }
    nikudKeys['home'] = () => { 
      if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) this.moveToFirstOption()
    }
    nikudKeys['end'] = () => { 
      if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) this.moveToLastOption()
    }
    nikudKeys['up'] = () => { 
      if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) this.moveToPreviousOption()
    }
    nikudKeys['V'] = () => { 
      if (this.localNikudKeyboard === 'blind' && !(this.localLetterAddingMode)
          && !(this.modalOpen()) && this.currentLetterNotSep) {
        this.moveToNextOption()
      }
    }
    nikudKeys['M'] = () => { 
      if (this.localNikudKeyboard === 'blind' && !(this.localLetterAddingMode)
          && !(this.modalOpen()) && this.currentLetterNotSep) {
        this.moveToPreviousOption()
      }
    }
    nikudKeys['shift+M'] = () => {
      if (!(this.modalOpen())) {
        if (!(this.paneOpen)) this.subPanesStatus.optionsOpen = true
        this.modesObj.showMorph = !(this.modesObj.showMorph)
        // if (this.showMorph) {
        //   console.log(JSON.stringify(this.localCurrentWord.options.map(o => o.morphArray.map(m => this.getAllMorphStrings(m[0])))))
        // }
      }
    }
    nikudKeys['ctrl+M'] = () => {
      if (!(this.modalOpen())) {
        if (!(this.paneOpen)) this.subPanesStatus.optionsOpen = true
        this.modesObj.showMorph = !(this.modesObj.showMorph) // console.log is ONLY with SHIFT!
      }
    }
    if (this.implementUserAccounts) {
      nikudKeys['shift+Q'] = () => {
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) {
          if (((this.workingOption > 0) || !(this.relevantOptionsFromUserDictionary.length))
              && this.workingOption < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length
              && (this.localCurrentWord.choiceType === 'option')) {
            this.moveShownOptionToEnd('top', this.workingOption)
          }
        }
      }
      nikudKeys['ctrl+Q'] = () => {
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) {
          if (((this.workingOption > 0) || !(this.relevantOptionsFromUserDictionary.length)) 
              && this.workingOption < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length
              && (this.localCurrentWord.choiceType === 'option')) {
            this.moveShownOptionToEnd('top', this.workingOption)
          }
        }
      }
      nikudKeys['shift+x'] = () => {
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep
            && this.workingOption >= this.relevantOptionsFromUserDictionary.length) {
          if (this.workingOption < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length) {
            if (this.optionsToShow[this.workingOption].displayText === this.localCurrentWord.chosenWordString) {
              this.moveShownOptionToEnd('bottom', this.workingOption)
            }
          } else {
            this.useNewChoice()
            this.removeFromUserDictionaryNegatives(this.optionsToShow[this.workingOption].displayText)
            this.initWorkingOption()
          }
        }
      }
      nikudKeys['alt+shift+Q'] = () => {
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) {
          if (this.workingOption < this.relevantOptionsFromUserDictionary.length) {
            this.removeFromUserDictionary(this.workingOption)
          }
        }
      }
      nikudKeys['escape'] = () => { if (this.showAccountNeededPopup && !(this.modalOpen())) this.showAccountNeededPopup = false }
    }
    return {
      keymap: nikudKeys
      // the ABOVE [starts by] creating key and value pairs like the BELOW for all the keys in the "order"
      //   'A': () => { this.changeWorkingOption(optionsPaneKeyOrder.indexOf('A')) },
      //   'X': () => { this.changeWorkingOption(optionsPaneKeyOrder.indexOf('X')) },
    }
  }
}
